import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { selectCorePageUrl } from 'store/lists/selectors';

const CorePageUrl = ({ label, prefix }) => {
  const url = useSelector(state =>
    selectCorePageUrl(state, 'beacon-pages-suggestions', label, prefix)
  );

  return url;
};

CorePageUrl.propTypes = {
  label: PropTypes.string.isRequired,
  prefix: PropTypes.string.isRequired
};

export default CorePageUrl;
